export default __webpack_public_path__ + "static/media/mt.5fbb4941.svg";